import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import { type ExperienceMultiSurveyCardReasonSection } from '@bbkAdminRedux/rtkq/experience.slice';
import { type ElementType, type ReactFCC } from '@bbkAdminUtils/utility-types';
import { FunnelInput } from '@bbkFunnel/components/v2';
import { type SurveyMultiRowResponse } from '@bbkFunnelComponents/survey-multi-row';

export type ReasonOtherHandler = (
  value: string,
  type: 'reason_other',
  tier: string,
  opts: { target: { type: 'track' | 'change' } },
  trackTypeOpts: { type: 'track' | 'change' }
) => void;

type Props = {
  showOther: boolean;
  reasonOtherTextVal: string;
  handleOtherText: ReasonOtherHandler;
  tierValue: string;
  question: ExperienceMultiSurveyCardReasonSection;
  selectedItem?: ElementType<SurveyMultiRowResponse['reason_for_leaving']>;
};
export const ReasonOtherText: ReactFCC<Props> = (props) => {
  const otherInputRef = useRef<HTMLInputElement>(null);
  const {
    showOther,
    reasonOtherTextVal,
    handleOtherText,
    tierValue,
    question,
    selectedItem,
  } = props;

  const options = _.get(question, 'options', []);
  const otherQuestion = _.find(options, {
    value: _.get(selectedItem, 'value'),
  });
  const placeholder = _.get(otherQuestion, 'placeholder', '');

  useEffect(() => {
    otherInputRef.current?.focus();
  }, [showOther]);

  return (
    <div>
      {showOther && (
        <div className="other-input">
          <FunnelInput
            ref={otherInputRef}
            placeholder={placeholder}
            name="ReasonOtherText"
            value={reasonOtherTextVal}
            onChange={({ target: { value } }) => {
              handleOtherText(
                value,
                'reason_other',
                tierValue,
                {
                  target: { type: 'change' },
                },
                { type: 'change' }
              );
            }}
            onBlur={({ target: { value } }) => {
              handleOtherText(
                value,
                'reason_other',
                tierValue,
                {
                  target: { type: 'change' },
                },
                { type: 'track' }
              );
            }}
            maxLength={140}
          />
        </div>
      )}
    </div>
  );
};
